import {inject, Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {STORE_AUTH_KEY, initialAuthState} from '../@types';
import {environment} from '../../../environments/environment';
import {AuthState, UserAuthData} from '../stores/auth/reducers/auth.reducer';
import {LoginFormData} from '../../features/login/@types';
import {SessionStorageService} from '../storages/session-storage.service';
import {LocalStorageService} from '../storages/local-storage.service';
import {ApiWebService} from '../../shared/@types';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends ApiWebService {

  private sessionStorage = inject(SessionStorageService);
  private localStorage = inject(LocalStorageService);

  constructor() {
    super('token');
  }

  loginUser(loginData: LoginFormData): Observable<UserAuthData> {
    return this.client.post<UserAuthData>(environment.authUrl, loginData).pipe(
      map((res: UserAuthData) => res)
    );
  }

  storageAuthData(authState: AuthState, remeberMe: boolean): void {
    if (remeberMe) {
      this.localStorage.patchItem(STORE_AUTH_KEY, authState, initialAuthState);
    } else {
      this.sessionStorage.patchItem(STORE_AUTH_KEY, authState, initialAuthState);
    }
  }

  removeStoredAuthData(): void {
    const localData = this.localStorage.getItem(STORE_AUTH_KEY);
    if (localData) {
      // Lascio memorizzato solo i loginFormData se presenti per la memorizzazione dell'accesso
      const {loginFormData} = localData;
      this.localStorage.setItem(STORE_AUTH_KEY, {...initialAuthState, loginFormData});
    }
    this.sessionStorage.removeItem(STORE_AUTH_KEY);
  }

}
